'use client';

import type React from 'react';
import { useState, useCallback, useRef } from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover';

import RenderMaps from 'src/components/shared/map/map';

import { useAppDispatch } from 'src/hooks/redux-hooks';
import { updateVisibility } from 'src/redux/modals/slice';
import type { JobData } from 'src/types';
import type { PopoverPosition } from 'react-tiny-popover';

interface PopoverContentProps {
  position: PopoverPosition;
  childRect: DOMRect;
  popoverRect: DOMRect;
}

interface TenantAddressProps {
  job: JobData | Record<string, unknown>;
}

const TenantAddress: React.FC<TenantAddressProps> = ({ job }) => {
  const dispatch = useAppDispatch();
  const [popoverOpen, setPopoverOpen] = useState(false);
  const openTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const location = (
    job as Record<string, unknown>
  )?.location as
    Record<string, unknown> | undefined;
  const tenantInfo = job?.tenant_info as Record<string, unknown> | undefined;

  const handleMouseEnter = useCallback(() => {
    openTimerRef.current = setTimeout(() => {
      setPopoverOpen(true);
    }, 200);
  }, []);

  const handleMouseLeave = useCallback(() => {
    clearTimeout(openTimerRef?.current as ReturnType<typeof setTimeout>);
    setPopoverOpen(false);
  }, []);

  const popoverContent = useCallback((props: PopoverContentProps) => {
    if (location?.latitude && location?.longitude) {
      return (
        <ArrowContainer
          position={props.position}
          childRect={props.childRect}
          popoverRect={props.popoverRect}
          arrowColor="white"
          arrowSize={8}
          className="popover-arrow-container"
          arrowClassName="popover-arrow"
          style={{ zIndex: 99999 }}
          arrowStyle={{ top: '40px' }}
        >
          <div className="maps">
            <RenderMaps
              center={{
                lat: Number(location?.latitude),
                lng: Number(location?.longitude),
              }}
              containerStyle={{
                width: '400px',
                height: '400px',
              }}
            />
          </div>
        </ArrowContainer>
      );
    }
    return <div />;
  }, [location?.latitude, location?.longitude]);

  return (
    <div className="job-content-data">
      <p>
        {(tenantInfo?.address as string) || ''}
        <span>
          {' '}

          <Popover
            isOpen={popoverOpen}
            positions={['left']}
            reposition={false}
            containerClassName="location-map-popover"
            boundaryElement={document.getElementsByClassName('lp-jd')[0] as HTMLElement}
            content={popoverContent}
            containerStyle={{ top: '100px' }}
          >
            <span
              className="btn-link view-map-btn"
              role="presentation"
              onClick={() => {
                dispatch(
                  updateVisibility({
                    isVisible: true,
                    modalType: 'mapModal',
                    extraProps: {
                      modalData: {
                        address: tenantInfo?.address,
                        job_count: (job as Record<string, unknown>)?.job_history_count,
                        latitude: Number(location?.latitude),
                        longitude: Number(location?.longitude),
                      },
                    },
                  }),
                );
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {' '}
              view map
            </span>
          </Popover>
        </span>
      </p>
    </div>
  );
};

export default TenantAddress;
